module.exports = __webpack_public_path__ + "mo/img/00_UX-CX.974fd2df.png";